import { mediumGreen, red } from '@styles/theme';
import { keyframes, style } from '@vanilla-extract/css';

const appear = keyframes({
  from: { fill: mediumGreen },
  to: { fill: red },
});

export const hat = style({
  width: '100%',
  fill: red,
  animation: `${appear} 1.5s ease-out`,
});
